<div class="modal-container-custom">
  <div class="modal-content-custom uploadSignedStyle_1">
    <div class="modal-header">
      <button type="button" class="close" aria-label="Close" id="edit-cp-modal-close"
        (click)="activeModal.close(false)">
        <span>&times;</span>
      </button>
      <h4 class="modal-title enabled-text">
        {{modalDisplayTitle}}
      </h4>
    </div>
    <div class="modal-body my-3">
      <div class="dark-section my-2 py-4 px-4">
        <h5 class="mt-4 mb-5 enabled-text" *ngIf="docsWithSignatories.length > 0">Selected Signatories</h5>
        <div class="row mx-0 fs-14" *ngFor="let signatoryDoc of docsWithSignatories; let idx = index">
          <p class="col-4 px-0 ">{{idx + 1}}.
            {{documentNamesMap[signatoryDoc.document_name]}}</p>
          <p class="col-8 px-0 enabled-text">
            <span *ngFor="let signatory of signatoryDoc.selectedSignatories; let isLast = last;">
              {{signatory.name}} 
              <span *ngIf="signatory.group_name" class="warning-text font-style-normal">({{signatory.group_name}})</span>
              {{isLast ? '': ', '}}
            </span>
          </p>
        </div>

        <h5 class="mt-6 mb-5 enabled-text" *ngIf="uploadedDocs.length > 0">Signed Docs to Upload</h5>
        <div class="row mx-0 fs-14" *ngFor="let docUpload of uploadedDocs; let idx = index">
          <p class="col-4 px-0">{{idx + 1}}.
            {{documentNamesMap[docUpload.document_name]}} ({{docUpload.investor_comp_name}})</p>
          <p class="col-8 px-0">
            <span (click)="showDocInModal(docUpload)" class="cp-action-link text-italic">
              View Uploaded Document
            </span>
          </p>
        </div>

        <div class="row mt-5 mb-4 mx-0">
          <span class="col-12 warning-text">
            {{modalDisplayConfirmMsg}}
          </span>
        </div>
      </div>
    </div>

    <div class="modal-footer modal-footer-custom justify-content-between">
      <button type="button" id="cancel-send-for-signing"
        class=" btn btn-outline-normal btn-style-right-1 text-left" (click)="closeModal(false)">Cancel</button>
      <button type="button" id="confirm-send-for-signing"
        class="btn btn-md btn-style-right-1 btn-success text-left" (click)="closeModal(true)">Confirm</button>
    </div>
  </div>
</div>

<!-- Modal to view PDF -->
<div class="modal fade" id="pdfModal" tabindex="-1" aria-labelledby="pdfModalLabel" role="dialog">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header pdfHeader">
        <h4 class="col-12 modal-title enabled-text" id="{{docUploadId}}">{{docUploadTitle}}</h4>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="closePDFModal()">
          <span>&times;</span>
        </button>
      </div>
      <embed class="pdfDocView" id="pdf-doc-embed" [attr.src]="pdfUrl" type="application/pdf"> 
    </div>
  </div>
</div>
